import React, { useState, useRef, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import EditRoundedIcon from '@material-ui/icons/EditRounded';
import IconButton from '@material-ui/core/IconButton';
import Swal from 'sweetalert2';
import Grid from '@material-ui/core/Grid';
import consultaApi from '../../../services/consultaApi';
import Typography from '@material-ui/core/Typography';
import VisibilityIcon from '@material-ui/icons/Visibility';
import AddCircleOutlineOutlinedIcon from '@material-ui/icons/AddCircleOutlineOutlined';

const useStyles = makeStyles(theme => ({
    controlaTitulo: {
        fontSize: "1.2em",
    },
    botaoRodape: {
        padding: theme.spacing(1),
    },
    controlaAddMensagem: {
        margin: "0px 0px 5px 0px"
    }
}))

export default function FormMensagemNfe(props) {

    const { adicionarMensagem, removerMensagem, grid, mensagemNfe, indexMensagem, inativo } = props;


    const classes = useStyles();

    const [codigoMensagem, setCodigoMensagem] = useState(mensagemNfe ? mensagemNfe.codigoMensagem : 0);

    const [tipoMensagem, setTipoMensagem] = useState(mensagemNfe ? mensagemNfe.tipoMensagem : 1);
    const [tipoMensagemErro] = useState(false);
    const [tipoMensagemErroTexto] = useState();

    const [texto, setTexto] = useState(mensagemNfe ? mensagemNfe.texto : '');
    const [textoErro, setTextoErro] = useState(false);
    const [textoErroTexto, setTextoErroTexto] = useState();

    const [open, setOpen] = React.useState(false);
    const inputLabel = useRef(null);
    const [labelWidth] = useState(0);

    useEffect(() => {
        if (mensagemNfe) {
            return
        }
        if (open) {
            setCodigoMensagem(0);
            setTipoMensagem(1);
            setTexto('');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open])

    function validaCampos() {
        let camposErrados = [];
        if (texto === '') {
            setTextoErro(true);
            setTextoErroTexto("Por favor preencha o Texto,campo obrigatorio");
            camposErrados.push("Texto");
        } else {
            setTextoErro(false);
        }

        if (camposErrados.length === 0) {
            return true;
        } else {
            return false;
        }
    }

    function salvar() {
        if (validaCampos()) {
            setOpen(false);
            adicionarMensagem(
                {
                    codigoMensagem,
                    tipoMensagem,
                    texto,
                }, indexMensagem);

            const Toast = Swal.mixin({
                toast: true,
                position: 'top-right',
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                onOpen: (toast) => {
                    toast.addEventListener('mouseenter', Swal.stopTimer)
                    toast.addEventListener('mouseleave', Swal.resumeTimer)
                }
            })

            Toast.fire({
                type: 'success',
                title: 'Mensagem Salva'
            })
        }

    }

    function cancelar() {
        setOpen(false);
    }


    function apresentarDeletar() {
        if (mensagemNfe && !inativo) {
            return <Grid item xs={6} className={classes.botaoRodape}>
                <Button
                    variant="contained"
                    color="secondary"
                    type="button"
                    onClick={deletar}
                    fullWidth
                >
                    Deletar
                </Button>
            </Grid>
        }
    }

    async function deletar() {
        if (codigoMensagem) {

            let dadosEnvio = {
                PROCNAME: "WEBSITE_NFMSG_DELETE",
                PCNRNFI: codigoMensagem
            };

            const resposta = await consultaApi(dadosEnvio);

            // eslint-disable-next-line eqeqeq
            if (resposta.data.CODIGO_ERRO == 0) {
                setOpen(false);
                removerMensagem(indexMensagem);
                const Toast = Swal.mixin({
                    toast: true,
                    position: 'top-right',
                    showConfirmButton: false,
                    timer: 3000,
                    timerProgressBar: true,
                    onOpen: (toast) => {
                        toast.addEventListener('mouseenter', Swal.stopTimer)
                        toast.addEventListener('mouseleave', Swal.resumeTimer)
                    }
                })

                Toast.fire({
                    type: 'success',
                    title: 'Item Removido'
                })
            }
        } else {
            setOpen(false);
            removerMensagem(indexMensagem);
            const Toast = Swal.mixin({
                toast: true,
                position: 'top-right',
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                onOpen: (toast) => {
                    toast.addEventListener('mouseenter', Swal.stopTimer)
                    toast.addEventListener('mouseleave', Swal.resumeTimer)
                }
            })

            Toast.fire({
                type: 'success',
                title: 'Item Removido'
            })
        }

    }

    const handleOpen = (e) => {
        e.preventDefault();
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <div>
            {grid ? <IconButton aria-label="alterar"
                onClick={handleOpen}
            >
                {inativo ? <VisibilityIcon /> : <EditRoundedIcon />}
            </IconButton> : <Button
                type="button"
                variant="contained"
                onClick={handleOpen}
                disabled={inativo}
                color="secondary"
                fullWidth
                className={classes.controlaAddMensagem}
                startIcon={<AddCircleOutlineOutlinedIcon />}
            >
                Adicionar Mensagem
            </Button>}
            <Dialog
                open={open}
                onClose={handleClose}
                scroll='paper'
                aria-labelledby="scroll-dialog-title"
                aria-describedby="scroll-dialog-description"
                fullScreen
            >
                <DialogTitle id="scroll-dialog-title">
                    <Grid container>
                        <Grid item xs={mensagemNfe ? 6 : 12} className={classes.botaoRodape}>
                            <Typography
                                variant="h1"
                                component="h1"
                                gutterBottom
                                align="center"
                                color="primary"
                                className={classes.controlaTitulo}
                            >
                                Mensagens
                            </Typography>
                        </Grid>

                        {apresentarDeletar()}

                    </Grid>
                </DialogTitle>
                <DialogContent dividers='true'>
                    <DialogContentText
                        id="scroll-dialog-description"

                        tabIndex={-1}
                    >

                        <form>

                            <FormControl
                                variant="outlined"
                                fullWidth
                                disabled={inativo}
                            >

                                <InputLabel ref={inputLabel}>
                                    Tipo Mensagem
                                </InputLabel>


                                <Select
                                    error={tipoMensagemErro}
                                    helperText={tipoMensagemErroTexto}
                                    value={tipoMensagem}
                                    onChange={e => setTipoMensagem(e.target.value)}
                                    labelWidth={labelWidth}
                                >
                                    <MenuItem value={1}>Usuário</MenuItem>
                                    <MenuItem value={0}>Fisco</MenuItem>
                                </Select>

                            </FormControl>

                            <TextField
                                fullWidth
                                label="Texto"
                                error={textoErro}
                                helperText={textoErroTexto}
                                margin="normal"
                                variant="outlined"
                                value={texto}
                                onChange={e => setTexto(e.target.value)}
                                multiline="true"
                                rows="5"
                                disabled={inativo}
                            />

                        </form>

                    </DialogContentText>

                </DialogContent>
                <DialogActions>
                    <Grid container>
                        {inativo ? <Grid item xs={12} className={classes.botaoRodape}>
                            <Button
                                variant="contained"
                                color="secondary"
                                type="button"
                                onClick={cancelar}
                                fullWidth
                            >
                                Sair
                                </Button>
                        </Grid> : <>
                            <Grid item xs={6} className={classes.botaoRodape}>
                                <Button
                                    variant="contained"
                                    color="secondary"
                                    type="button"
                                    onClick={cancelar}
                                    fullWidth
                                >
                                    Cancelar
                                    </Button>
                            </Grid>
                            <Grid item xs={6} className={classes.botaoRodape}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    type="submit"
                                    onClick={salvar}
                                    fullWidth
                                >
                                    Salvar
                                    </Button>
                            </Grid>
                        </>}
                    </Grid>
                </DialogActions>
            </Dialog>
        </div>
    )
}